var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16667 0C0.971615 0 0 0.84082 0 1.875V13.125C0 14.1592 0.971615 15 2.16667 15H10.8333C12.0284 15 13 14.1592 13 13.125V4.6875H8.66667C8.06745 4.6875 7.58333 4.26855 7.58333 3.75V0H2.16667ZM8.66667 0V3.75H13L8.66667 0ZM2.70833 1.875H4.875C5.17292 1.875 5.41667 2.08594 5.41667 2.34375C5.41667 2.60156 5.17292 2.8125 4.875 2.8125H2.70833C2.41042 2.8125 2.16667 2.60156 2.16667 2.34375C2.16667 2.08594 2.41042 1.875 2.70833 1.875ZM2.70833 3.75H4.875C5.17292 3.75 5.41667 3.96094 5.41667 4.21875C5.41667 4.47656 5.17292 4.6875 4.875 4.6875H2.70833C2.41042 4.6875 2.16667 4.47656 2.16667 4.21875C2.16667 3.96094 2.41042 3.75 2.70833 3.75ZM3.25 6.5625H9.75C10.3492 6.5625 10.8333 6.98145 10.8333 7.5V9.375C10.8333 9.89355 10.3492 10.3125 9.75 10.3125H3.25C2.65078 10.3125 2.16667 9.89355 2.16667 9.375V7.5C2.16667 6.98145 2.65078 6.5625 3.25 6.5625ZM3.25 7.5V9.375H9.75V7.5H3.25ZM8.125 12.1875H10.2917C10.5896 12.1875 10.8333 12.3984 10.8333 12.6562C10.8333 12.9141 10.5896 13.125 10.2917 13.125H8.125C7.82708 13.125 7.58333 12.9141 7.58333 12.6562C7.58333 12.3984 7.82708 12.1875 8.125 12.1875Z",
    fill: "#373939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.fd8515ad2fafca9f2e95537fb755e85c.svg";
export { ForwardRef as ReactComponent };